import { memo, useLayoutEffect, useRef } from 'react';
import { isAbleToBookSelector } from '@lingoda/booking';
import { useUpcomingAppointmentsCount } from '@lingoda/classes';
import { useIsFFreeTrialOrWasInTrial } from '@lingoda/f-free-trial';
import { useSelector } from '@lingoda/hooks';
import { pendingNotificationsSelector } from '@lingoda/notifications';
import type { RouteConfigExtended } from '@lingoda/router';
import type { TabsActions } from '@lingoda/ui';
import { useStudentActiveTab } from '../../../hooks/useStudentActiveTab';
import { Layout } from './Layout';

interface Props {
    routes: RouteConfigExtended[];
    onChange?: () => void;
}

const HeaderTabs = ({ routes, onChange, ...props }: Props) => {
    const actionsRef = useRef() as React.MutableRefObject<TabsActions>;
    const { currentTabValue, handleChange } = useStudentActiveTab({
        routes,
        onChange,
    });
    const isAbleToBook = useSelector(isAbleToBookSelector);
    const notificationsCount = useSelector(pendingNotificationsSelector).length;
    const isFFreeTrialOrWasInTrial = useIsFFreeTrialOrWasInTrial();
    const { hasUpcomingAppointments } = useUpcomingAppointmentsCount();
    const hasAccessToClasses = isAbleToBook || hasUpcomingAppointments;

    useLayoutEffect(() => {
        actionsRef.current?.updateIndicator();
    }, [hasAccessToClasses, notificationsCount, actionsRef]);

    return (
        <Layout
            {...props}
            ref={actionsRef}
            handleChange={handleChange}
            value={currentTabValue}
            hasAccessToClasses={hasAccessToClasses}
            isFFreeTrialOrWasInTrial={isFFreeTrialOrWasInTrial}
        />
    );
};

export default memo(HeaderTabs);
